import styled from 'styled-components';


export const Nav = styled.nav`
display: flex;
height: 80px;
justify-content: center;
align-items: center;
position: sticky;
top: 0;
z-index: 999;
box-shadow: 0px 4px 4px 4px rgba(225, 225, 225, 0.5);
/* background: linear-gradient(to right bottom,
  
     rgba(128, 0, 0, 0.8)
     rgba(3, 138, 255, 0.5)
         ); */
background-color: rgba(128, 0, 0, 0.8);
backdrop-filter: blur(0.5rem);
`
export const NavContainer = styled.div`
display: flex;
justify-content: space-between;
width: 100%;
margin-right: auto;
margin-left: auto;
height: 80px;
z-index: 1;
align-items: center;
font-size: 25px;
`

export const LogoHold = styled.div`
margin-left: 20px;
font-weight: bold;
font-size: 30px;


img {
    height: 40px;
    width: 25px;
    border-radius: 15%;
}
`

export const MobileIcon = styled.div`
display: none;

@media screen and (max-width: 850px){
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 60%);
}
`
export const NavBar = styled.ul`
display: flex;
align-items: center;
list-style: none;
text-align: center;
width: 500px;
justify-content: space-between;
padding-right: 40px;
font-weight: bold;



@media screen and (max-width: 850px){
    display: flex;
    flex-direction: column;
    position: absolute;
    padding-right: 0;
    top: 10vh;
    height: 40vh;
    justify-content: flex-start;
    width: 100%;
    background: whitesmoke;
    left: ${({click}) => (click? 0 : '-100%')};
    opacity: 1;
    transition: all 0.5s ease;
    backdrop-filter: blur(0.5rem);
}
`

export const NavLinks = styled.div`
font-size: 20px;
cursor: pointer;
color: #CF8A2F;


&:hover{
    border-bottom: 2px solid whitesmoke;
}

@media screen and (max-width : 850px){
    margin-top: 20px;
    color: #CF8A2F;
}
`